import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import ProductionTracking from "./ProductionTracking";
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class ProductionTrackings extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'productiontracking',
            data: null,
            page: 1,
            per_page: 30,
            phrase: '',
            loading: true,
            systemModuleId: 35,
            menuId: 113,
            moduleAccessStatus: 1,
            reportMode: props.ReportMode,
        };

        this.state.filters = {
            personId: this.defaultGuid(),
            personMobile: '',
            personName: '',
            //status: (this.state.reportMode == 1 ? 2 : this.state.reportMode == 2 ? 1 : 0)
        }

        this.setMenuId();

        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    componentWillReceiveProps(props) {
        if (props.ReportMode == this.state.reportMode) return;
        this.state.reportMode = props.ReportMode;
        //this.state.filters.status = (this.state.reportMode == 1 ? 2 : this.state.reportMode == 2 ? 1 : 0);

        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    setMenuId() {
        if (this.state.reportMode === 1) this.state.menuId = 113;
        if (this.state.reportMode === 2) this.state.menuId = 193;
    }
    onView(id) {
        this.removeKeyDown();
        this.showComponents({ component: <ProductionTracking Caller={this} Id={id} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">تولیدات انجام شده</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} مورد یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderView()}
            </div>
        </div>
    }
    downloadCrm(id) {
        this.httpPost('api/v1/productiontracking/crm', {
            id: id,
        }).then((data) => {
            if (data.status === -1) window.location.href = '/login';
            if (data.status === 1) {
                this.downloadPDF(data.bs64);
            } else {
            }
        });
    }
    downloadStuffSend(id) {
        this.httpPost('api/v1/productiontracking/stuffsend', {
            id: id,
        }).then((data) => {
            if (data.status === -1) window.location.href = '/login';
            if (data.status === 1) {
                this.downloadPDF(data.bs64);
            } else {
            }
        });
    }
    renderView() {
        return <div className="nk-block">
            <div className="card card-bordered card-stretch">
                <div className="card-inner-group">
                    <div className="card-inner position-relative card-tools-toggle">
                        <div className="card-title-group">
                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                <div className="form-inline flex-nowrap gx-3">
                                    <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="شماره تولید" className="form-control" />
                                    </div>
                                    <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.filters.personName} onChange={e => this.state.filters.personName = e.target.value} placeholder="نام مشتری" className="form-control" />
                                    </div>
                                    <div className="form-wrap">
                                        <input type="text" defaultValue={this.state.filters.personMobile} onChange={e => this.state.filters.personMobile = e.target.value} placeholder="شماره موبایل مشتری" className="form-control" />
                                    </div>
                                    <div className="btn-wrap">
                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    {this.state.data.recordsCount <= 0 ?
                        <div className="card-inner-group">
                            <div className="example-alert">
                                <div className="alert alert-pro alert-warning">
                                    <div className="alert-text">
                                        <h6>توجه</h6>
                                        <p>هیچ تولیدی یافت نشد</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card-inner p-0">
                            <div className="nk-tb-list nk-tb-ulist">
                                <div className="nk-tb-item nk-tb-head">
                                    <div className="nk-tb-col text-center"><span className="sub-text">شماره</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">نام مشتری</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">موبایل مشتری</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">خط تولید</span></div>
                                    <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>
                                    {this.state.reportMode == 1 && <div className="nk-tb-col text-center"><span className="sub-text">پیگیری ها</span></div>}
                                    {this.state.reportMode == 2 && <div className="nk-tb-col text-center"><span className="sub-text">ارسال محصول</span></div>}
                                </div>
                                {this.state.data.records.map((record, index) =>
                                    <div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">
                                                <a className="text-primary txt-bold hand" onClick={e => this.onView(record.id)} title="مشاهده">
                                                    {record.fullNumber}
                                                </a>
                                            </span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.personName}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.personMobile}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.productionLines.map(item => <span style={{ "background-color": "#f8a602", "border-radius": "4px", "padding": "2px", "margin": "0 2px", "display": "inline-block" }} >{item.label}</span>)}</span>
                                        </div>
                                        <div className="nk-tb-col">
                                            <span className="sub-text text-center">{record.dateString}</span>
                                        </div>
                                        {this.state.reportMode == 1 && <div className="nk-tb-col">
                                            <span className="sub-text text-center">
                                                <a className="hand text-primary" onClick={e => this.downloadCrm(record.id)}>دانلود</a>
                                            </span>
                                        </div>}
                                        {this.state.reportMode == 2 && <div className="nk-tb-col">
                                            <span className="sub-text text-center">
                                                <a className="hand text-primary" onClick={e => this.downloadStuffSend(record.id)}>دانلود</a>
                                            </span>
                                        </div>}
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                    {this.createPaging()}
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.isEmpty(this.state.data.global.companies) ? [
                    <Header data={this.state.data} />,
                    <div className="nk-content ">
                        <div className="container-fluid">
                            <div className="nk-content-inner">
                                {this.renderNoCompanyRegister()}
                            </div>
                        </div>
                    </div>,
                    <Footer />,
                ] :
                    <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
                ,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}